import { jsx as f, jsxs as L } from "react/jsx-runtime";
import { c as m } from "./index-65016bfa.mjs";
import v, { useRef as O, useState as M, useEffect as j } from "react";
import N, { styled as x, css as a } from "styled-components";
import { QUERIES as Q } from "@fcamna/shared-component-foundations";
import { u as D } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as R } from "./useWindowDimensions-ae69e913.mjs";
import { u as E } from "./useMediaQuery-2533ee8a.mjs";
import { Tooltip as H } from "./tooltip.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./getElementPosition-a8642645.mjs";
const I = x.button`
  &.SegmentControlItem {
    ${({
  theme: {
    components: { segmentControl: e }
  }
}) => a(e.SegmentControlItem)};
  }
`, P = x.label`
  &.SegmentControlItem__label {
    ${({
  theme: {
    components: { segmentControl: e }
  }
}) => a(e.SegmentControlLabel)};
  }
`, U = x.div`
  &.SegmentControlItem__icon {
    ${({
  theme: {
    components: { segmentControl: e }
  }
}) => a(e.SegmentControlItemIcon)};
  }
`, V = ({
  leftIcon: e,
  label: p,
  ariaLabel: _,
  dataTestId: C,
  className: c,
  _itemIndex: h = 0,
  value: d = `${h + 1}`,
  _onChange: u,
  isDisabled: o = !1,
  ...$
}) => {
  const t = O(null), r = E(Q.mobile), [S, g] = M(!1);
  j(() => {
    if (!t.current)
      return;
    const i = t.current.scrollWidth > (t == null ? void 0 : t.current.clientWidth);
    g(i);
  }, [p]);
  function b(i) {
    r && i.currentTarget.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    }), u == null || u(i, d, h);
  }
  return /* @__PURE__ */ f(
    H,
    {
      className: "SegmentControlItem__Tooltip",
      "data-value": d,
      isDisabled: !S,
      title: p || "",
      placement: "auto",
      showLargeContent: !0,
      children: /* @__PURE__ */ L(
        I,
        {
          ...$,
          type: "button",
          value: d,
          onClick: b,
          "aria-label": _,
          "data-testid": C,
          disabled: o,
          className: m([
            "SegmentControlItem",
            { "SegmentControlItem--disabled": o, "SegmentControlItem--with-icon": e },
            c
          ]),
          children: [
            e && /* @__PURE__ */ f(U, { className: m(["SegmentControlItem__icon", "SegmentControlItem__icon--left"]), children: e }),
            /* @__PURE__ */ f(
              P,
              {
                ref: t,
                className: m(["SegmentControlItem__label"]),
                children: p
              }
            )
          ]
        }
      )
    }
  );
}, B = N.div`
  &.SegmentControl-wrapper {
    ${({
  theme: {
    components: { segmentControl: e }
  }
}) => a(e.SegmentControlWrapper)};
  }
`, F = N.div`
  &.SegmentControl {
    ${({
  theme: {
    components: { segmentControl: e }
  }
}) => a(e.SegmentControl)};
  }
`, G = N.div`
  &.SegmentControl__indicator {
    ${({
  theme: {
    components: { segmentControl: e }
  }
}) => a(e.SegmentIndicator)};
  }
`, J = ({ size: e = "medium", className: p, children: _, onChange: C, activeItem: c, id: h, autoWidth: d }) => {
  const u = D({ label: "Segment Control" }), o = O(null), { width: $ } = R();
  return j(() => {
    var r, S, g, b, i, T;
    let t = 0;
    if (o.current) {
      const n = o.current.parentElement, y = o.current.querySelector(".SegmentControl__indicator"), s = o.current.querySelectorAll(".SegmentControlItem__Tooltip");
      let w = !0, W = 0;
      for (let l = 0; l < s.length; l++)
        w && s[l].getAttribute("data-value") === c && (t = l, W += ((r = s[l]) == null ? void 0 : r.offsetWidth) / 2, w = !1), w && (W += (S = s[l]) == null ? void 0 : S.offsetWidth);
      n != null && n.clientWidth && (n == null ? void 0 : n.clientWidth) < o.current.clientWidth && (o.current.setAttribute("style", `translate: calc(${n.clientWidth / 2}px - ${W}px)`), n.scrollLeft = 0);
      const k = {
        left: (g = s[t]) == null ? void 0 : g.offsetLeft,
        top: (b = s[t]) == null ? void 0 : b.offsetTop,
        width: (i = s[t]) == null ? void 0 : i.offsetWidth,
        height: (T = s[t]) == null ? void 0 : T.offsetHeight
      }, A = Object.entries(k).map(([l, q]) => `${l}: ${q}px`).join("; ");
      y == null || y.setAttribute("style", A);
    }
  }, [c, $, e]), /* @__PURE__ */ f(
    B,
    {
      className: m(["SegmentControl-wrapper"]),
      ...u,
      children: /* @__PURE__ */ L(
        F,
        {
          id: h,
          className: m(["SegmentControl", `SegmentControl--${e}`, p]),
          ref: o,
          children: [
            /* @__PURE__ */ f(G, { className: "SegmentControl__indicator" }),
            v.Children.map(_, (t, r) => v.cloneElement(t, {
              _onChange: C,
              _itemIndex: r,
              key: (t == null ? void 0 : t.props.label) || r,
              className: m([
                t == null ? void 0 : t.props.className,
                `SegmentControlItem--${e}`,
                {
                  "SegmentControlItem--active": !(t != null && t.props.isDisabled) && (c === (t == null ? void 0 : t.props.value) || c === `${r + 1}`),
                  "SegmentControlItem--auto-width": d
                }
              ])
            }))
          ]
        }
      )
    }
  );
};
J.Item = V;
export {
  J as SegmentControl
};
